export default __webpack_public_path__ + "static/media/img1.6f442b56.png";